import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { getAppContext } from 'config/AppContext';
import useLocationManager from "utilities/hooks/useLocationManager";

const AppPrinter = () => {
    const locationManager = useLocationManager();
    const context = getAppContext(useContext);
    context.setLocationManagerData(locationManager);
    return (
        <main>
            <Outlet />
        </main>
    );
};

export default AppPrinter;
